import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AppLayout from "layouts/app-layout";
import AuthLayout from "layouts/auth-layout";
import { useAuth } from "data/hooks/useAuth";

export const APP_PREFIX_PATH = "/cms";
export const AUTH_PREFIX_PATH = "/auth";

// A wrapper that routes user to the dashboard when he/she lands on
// the login page while already authenticated
const CheckAlreadyAuthenticated = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();

  // Show nothing while loading
  if (loading) return null;

  // If authenticated and email verified, redirect to app
  if (isAuthenticated && user?.emailVerified) {
    return <Navigate to={APP_PREFIX_PATH} replace />;
  }

  // Otherwise show auth pages
  return children;
};

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated or if auth is not
// yet loaded
const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  // Show nothing while loading
  if (loading) return null;

  // If authenticated, show protected content
  if (isAuthenticated) {
    return children;
  }

  // Otherwise redirect to login
  return <Navigate to={AUTH_PREFIX_PATH} replace />;
};

export const Views = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Navigate to={APP_PREFIX_PATH} replace />
          </>
        }
      />
      <Route
        path={AUTH_PREFIX_PATH + "/*"}
        element={
          <>
            <CheckAlreadyAuthenticated>
              <AuthLayout />
            </CheckAlreadyAuthenticated>
          </>
        }
      />
      <Route
        path={APP_PREFIX_PATH + "/*"}
        element={
          <>
            <PrivateRoute>
              <AppLayout location={location} />
            </PrivateRoute>
          </>
        }
      />
    </Routes>
  );
};

export default Views;
